export default function Footer() {}

